'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * "Contact Us" Modal
 *
 * May want to break this out into its own component, but for now
 * it's only being used in the CorporatePricingLevel component so
 * we'll keep it here for now.
 *
 * Also uses 'contact-us-modal.scss'
 */
var ContactUsSuccess = _react2['default'].createClass({
    displayName: 'ContactUsSuccess',
    componentDidMount: function componentDidMount() {
        if (process.env.NODE_ENV !== 'test') {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
        if (process.env.NODE_ENV !== 'test') {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            { className: 'm-contact-us text-center l-padding-h-80' },
            _react2['default'].createElement('img', { className: 'l-padding-v-20 m-contact-us--checkmark', src: require('./checkmark_green@2x.png') }),
            _react2['default'].createElement(
                'h4',
                null,
                'Thanks for reaching out.',
                _react2['default'].createElement('br', null),
                'We\'ll get back to you shortly.'
            )
        );
    }
});

module.exports = ContactUsSuccess;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/contact-us-success.jsx
 ** module id = 1073
 ** module chunks = 0
 **/